import { ScopeStreams } from '@shared/app/scripts/services/scope-streams';

import { includes } from 'lodash';
import { filter, takeUntil } from 'rxjs/operators';

/**
 * A directive that triggers a callback function, everytime when a key is released.
 * keyup events are global, and provided by {@link coreModule.keyStreams}
 *
 * # Attributes
 * sw-keyup - callback function
 * key - expression that evaluates to key value (letters)
 *
 * if the key attribute is missing, we default to listening to all keyup events
 *
 * # Examples
 * {@link https://core.dev.swcloud.nl/#/reusable-components/keyup interactive example}
 * <pre>
 *   <div sw-keyup="action()" key="'a'"></div>
 * </pre>
 * calls `action()` every time when key 'a' (case sensitive) is released

 * <pre>
 *   <div sw-keyup="action()"></div>
 * </pre>
 * calls `action()` every time when *any* key is pressed
 */
angular
  .module('coreModule')
  .directive(
    'swKeyup',
    ($parse: ng.IParseService, scopeStreams: ScopeStreams, keyStreams) => {
      return function (scope, element, attrs) {
        const keyParser = $parse(attrs.key),
          swKeyup = $parse(attrs.swKeyup);

        keyStreams.keyup$
          .pipe(
            filter((event: KeyboardEvent) => {
              const keyValue = keyParser(scope);

              if (angular.isArray(keyValue)) {
                return includes(keyValue, event.key);
              } else if (keyValue) {
                return keyValue === event.key;
              } else {
                return true;
              }
            }),
            takeUntil(scopeStreams.isDestroyed(scope)),
          )
          .subscribe(() => {
            scope.$apply(() => {
              scope.$eval(swKeyup);
            });
          });
      };
    },
  );
